import { InfoPopover, RiCompass4Line, Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import {
  FactCapsule,
  FactCapsuleTrend,
} from '@/pages/shared/projects/pages/project/pages/conservation/shared/components/FactCapsule';
import { useFact } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useFact';

export const CarbonTile = () => {
  const { t } = useTranslation();

  const aboveGroundCarbonCurrentFact = useFact('r1_above_ground_carbon_i');
  const aboveGroundCarbonChangePctFact = useFact('r1_above_ground_carbon_pct_change');
  const aboveGroundCarbonBaselineFact = useFact('r1_above_ground_carbon_baseline');

  const baselineValueLabel = t('shared.ncaDetail.ecologicalIntegrity.breakdown.aboveGroundCarbon.baselineValue', {
    year: aboveGroundCarbonBaselineFact?.measured_at
      ? new Date(aboveGroundCarbonBaselineFact.measured_at).getFullYear()
      : null,
  });

  const currantValueLabel = t('shared.ncaDetail.ecologicalIntegrity.breakdown.aboveGroundCarbon.avgValue', {
    year: aboveGroundCarbonCurrentFact?.measured_at
      ? new Date(aboveGroundCarbonCurrentFact.measured_at).getFullYear()
      : null,
  });

  return (
    <Stack spacing={8} className='flex-1 rounded-[32px] bg-white-100 p-8'>
      <span className='typography-h3'>{t('global.analysis.carbon')}</span>
      <Stack spacing={12} className='rounded-2xl bg-bg-light-grey p-6 grow' centerCross>
        <ChartHeading
          heading={t('global.analysis.aboveGroundCarbon')}
          popover={
            <InfoPopover
              title={t('shared.ncaDetail.details.aboveGroundCarbon.explainers.aboveGroundCarbonStorage.title')}
              body={t('shared.ncaDetail.details.aboveGroundCarbon.explainers.aboveGroundCarbonStorage.body')}
              popoverTriggerProps={{
                className: 'text-text-secondary',
              }}
            />
          }
        />
        <FactCapsule
          label={baselineValueLabel}
          capsuleIconProps={{ icon: <RiCompass4Line />, variant: 'default' }}
          fact={aboveGroundCarbonBaselineFact}
        />
        <FactCapsule
          label={currantValueLabel}
          capsuleIconProps={{ icon: <RiCompass4Line />, variant: 'default' }}
          fact={aboveGroundCarbonCurrentFact}
          trend={<FactCapsuleTrend trend={aboveGroundCarbonChangePctFact} />}
        />
      </Stack>
    </Stack>
  );
};
